import React, { useState, useEffect } from "react";
import { BsFillCaretDownFill } from "react-icons/bs";
import { FaRegSquare, FaRegCheckSquare } from "react-icons/fa";
import clsx from "clsx";
import css from "./ServiceTypeSelect.module.css";
import { useCan } from "../../../../utils/permissions.js";

export default function ServiceTypeSelect({
  field,
  data, // доступні варіанти для вибору
  setFieldValue,
  placeholderName,
  isOpen,
  toggleDropdown,
  isDisabled,
  chosenServices, // дані, що прийшли з бази (recordById)
  openCreateServiceTypeModal,
  serviceId,
}) {
  const [searchQuery, setSearchQuery] = useState("");
  const dropDownRef = React.useRef(null); // Це стандарт для кліку "поза межами", не видаляв

  const can = useCan();

  const selectedOptions = field.value || [];
  // 1. Ефект ініціалізації: Записуємо дані з бази у Formik, якщо там порожньо
  useEffect(() => {
    if (
      chosenServices?.length > 0
      // && selectedOptions.length === 0
    ) {
      setFieldValue(field.name, chosenServices);
    }
  }, [chosenServices, setFieldValue, field.name]);

  // 2. Ефект розумного очищення: Спрацьовує при зміні serviceId
  useEffect(() => {
    // Якщо у нас є вибрані послуги, ми перевіряємо, чи вони взагалі існують у поточному списку 'data'
    // 'data' — це масив послуг, які підходять під вибраний serviceId
    if (selectedOptions.length > 0 && data.length > 0) {
      const firstSelected = selectedOptions[0];

      // Перевіряємо, чи перша вибрана послуга є в списку доступних (data)
      const isCorrectCategory = data.some(
        item => Number(item.id) === Number(firstSelected.id)
      );

      // Очищуємо ТІЛЬКИ якщо категорія змінилася на іншу (не ту, що в обраних)
      if (!isCorrectCategory) {
        setFieldValue(field.name, []);
      }
    }
  }, [serviceId, data]); // Стежимо за категорією та доступними даними

  const isChosen = id => selectedOptions.some(s => Number(s.id) === Number(id));

  const handleCheckboxClick = (id, option) => {
    const isExisted = isChosen(id);
    const nextValue = isExisted
      ? selectedOptions.filter(s => Number(s.id) !== Number(id))
      : [...selectedOptions, option];

    setFieldValue(field.name, nextValue);
  };

  const filteredOptions = data.filter(option =>
    option.name?.toLowerCase().includes(searchQuery.toLowerCase())
  );

  // Стандартна логіка закриття дропдауну
  useEffect(() => {
    const handleClick = e => {
      if (dropDownRef.current && !dropDownRef.current.contains(e.target))
        toggleDropdown(false);
    };
    if (isOpen) document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, [isOpen, toggleDropdown]);

  return (
    <div className={css.customSelect} ref={dropDownRef}>
      <div
        className={clsx(css.customSelectControl, {
          [css.customSelectControlOpen]: isOpen,
          [css.customSelectControlDisabled]: isDisabled,
        })}
        onClick={() => !isDisabled && toggleDropdown(!isOpen)}
      >
        <span
          className={clsx({
            [css.customSelectPlaceholder]: selectedOptions.length === 0,
            [css.customSelectInputSelected]: selectedOptions.length > 0,
          })}
        >
          {selectedOptions.length > 0
            ? selectedOptions.map(o => o.name).join(", ")
            : placeholderName}
        </span>
        <span className={css.customSelectArrow}>
          <BsFillCaretDownFill />
        </span>
      </div>

      {isOpen && (
        <div className={css.customSelectMenu}>
          <ul className={css.customSelectOptions}>
            {filteredOptions.length > 0 ? (
              filteredOptions.map(option => (
                <li
                  key={option.id}
                  className={css.customSelectOption}
                  onClick={() => handleCheckboxClick(option.id, option)}
                >
                  <p>
                    {option.name}{" "}
                    {Number(serviceId) === 1 && `| ${option.price}грн`}
                  </p>
                  {isChosen(option.id) ? <FaRegCheckSquare /> : <FaRegSquare />}
                </li>
              ))
            ) : (
              <li className={css.nothingFound}>Нічого не знайдено</li>
            )}
          </ul>
          <div className={css.btnWrapper}>
            <button
              type="button"
              className={css.chooseBtn}
              onClick={() => toggleDropdown(false)}
            >
              Обрати
            </button>
            {can("services", "create") && (
              <button
                type="button"
                className={css.addServiceBtn}
                onClick={openCreateServiceTypeModal}
              >
                Додати
              </button>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
